// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"638087b0","608":"7f511d3f","931":"d4accce5"}[chunkId] + ".chunk.css";
};